module.exports = __webpack_public_path__ + "img/contracted_store_title@2x.6d2cad2a.png";